import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import img01 from './../assets/solutions_products/digital_commerce.png'; // Adjust the path as necessary
import 'animate.css/animate.min.css'; // Import animate.css for animations



export default function DigitalCommerce() {
    return (
        <Container className='cybersecurity'>
            <h2 className="text-center title">Digital Commerce Platforms</h2>
            <Row>
                <div className='responsive-title'>Built to Sell Smarter, Scale Faster, and Serve Better</div>
            </Row>
            <Row className='mt-4'>
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeInUp" duration={.5} offset={100}>
                    <p className='text-center mb-4 content'>
                        In a world where speed, convenience, and personalization are everything your digital commerce system should do more than just "sell." We empower brands to run seamless, scalable, and fully connected commerce ecosystems with platforms that unify product, transaction, customer experience, and data from storefront to backend.
                    </p>
                    <p className='text-center mb-4 content'>
                        Whether you're launching a new product line or optimizing operations for hypergrowth, our stack is built to help you convert faster, retain longer, and grow smarter.
                    </p>
                </AnimationOnScroll>
            </Row>

            <Row>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.5} offset={100}>
                    <img src={img01} alt="Telecom Innovation Stack" className='img-fluid' style={{ width: '100%', height: 'auto', borderRadius: '25px' }} />
                    </AnimationOnScroll>
                </Col>
                <Col md={6} className='mb-4'>
                    <AnimationOnScroll animateOnce={true} animateIn="animate__flipInX" duration={.5} offset={100}>
                    <div className='mb-4 box'>
                        <div className='mb-4 box-title'>
                            What Powers Your Storefront:
                        </div>

                        <Row>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Product Catalog Systems</h4>
                                <p>Centralized product management with real time updates and multichannel sync.</p>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <h4>POS (Point of Sale) Solutions</h4>
                                <p>Fast, secure, and integrated payment systems online or offline.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Online Store Builders</h4>
                                <p>Customizable storefronts that match your brand, optimized for UX and conversion.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>Self-Care Tools</h4>
                                <p>Give customers more control with personalized dashboards, order tracking, and account management.</p>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <h4>CRM Platforms</h4>
                                <p>Understand and engage your buyers through data not guesswork.</p>
                            </div>



                        </Row>
                    </div>
                    </AnimationOnScroll>
                </Col>

            </Row>


        </Container>
    )

}